import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import ImageAndVideoUploadForm from '../../../../../../../components/form/ImageAndVideoUploadForm';
import { formRequiredRules } from '../../../../../../../lib/formRules';
import { MAXIMUM_NUMBER_OF_EVENT_VIDEO_SECTION_TYPE_IMG } from '../../../../../../../constants/service/app/eventConstants';
import { EventSectionAttachment } from '../../../../../../../types/query/event';

interface VideoSectionProps extends FormComponentProps {
  name: string;
  sectionAttachmentList?: EventSectionAttachment[];
}
const VideoSection = (props: VideoSectionProps) => {
  const { form, name, sectionAttachmentList } = props;

  return (
    <div>
      <ImageAndVideoUploadForm
        vertical={true}
        name={`${name}-attachments`}
        form={form}
        modalTitle="기획전 섹션 영상"
        label="기획전 섹션 영상"
        rules={[formRequiredRules(true, '필수 정보입니다.', false, 'array')]}
        initialValue={sectionAttachmentList}
        onlyVideo={true}
        maxCnt={MAXIMUM_NUMBER_OF_EVENT_VIDEO_SECTION_TYPE_IMG}
      />
    </div>
  );
};

export default VideoSection;
